import { Box, CardContent, Paper, SxProps, Typography } from "@mui/material";
import { FC, ReactNode, useState } from "react";

import DateSelectInputs from "../common/DateSelect";
import { Formik } from "formik";
import { subDays } from "date-fns";
import { createInitialDateValues } from "../client/types";
import { dateRangeValidation } from "../../shared/sharedFormSchema";

export const CardWrapper: FC<{
  children: ReactNode;
  id: string;
  defaultFromDate?: Date;
}> = ({ children, id, defaultFromDate }) => {
  const cardWidth = id === "projectInvestments" ? 350 : 275;

  // Capture the time bounds once at mount so subsequent re-renders don't
  // produce a fresh `Date.now()` — Formik only consumes `initialValues`
  // on first mount anyway, and reading the clock during render is not
  // pure.
  const [initialValues] = useState(() =>
    createInitialDateValues(
      id,
      (defaultFromDate ?? subDays(new Date(), 30)).getTime(),
      Date.now(),
    ),
  );

  return (
    <Paper
      elevation={1}
      sx={{
        height: "100%",
        minWidth: cardWidth,
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRadius: 2,
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={() => dateRangeValidation(id)}
        onSubmit={() => {}}
        validateOnBlur={true}
        validateOnChange={true}
      >
        <CardContent sx={{ flex: 1, p: 0 }}>{children}</CardContent>
      </Formik>
    </Paper>
  );
};

export const CardHeading: FC<{ heading: string }> = ({ heading }) => (
  <Typography
    variant="h5"
    component="h2"
    color="text.primary"
    gutterBottom
    sx={{ fontWeight: 500 }}
  >
    {heading}
  </Typography>
);

export const DateSelect: FC<{ dateName: string; minDate: Date }> = ({
  dateName,
  minDate,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <DateSelectInputs dateName={dateName} minDate={minDate} />
    </Box>
  );
};

export const ElementWrapper: FC<{ children: ReactNode; styles?: SxProps }> = ({
  children,
  styles,
}: {
  children: ReactNode;
  styles?: SxProps;
}) => <Box sx={{ ...styles }}>{children}</Box>;

export const Error: FC = () => (
  <Typography sx={{ fontSize: 36 }}>Error</Typography>
);
